import { render, staticRenderFns } from "./DistrictGroups.vue?vue&type=template&id=74dc4b0a"
import script from "./DistrictGroups.vue?vue&type=script&lang=ts"
export * from "./DistrictGroups.vue?vue&type=script&lang=ts"
import style0 from "./DistrictGroups.vue?vue&type=style&index=0&id=74dc4b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports